module.exports = __webpack_public_path__ + "static/img/unit-5.cb71f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-5.png
// module id = cILh
// module chunks = 51